var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5385 20.5H6.23077C5.90435 20.5 5.5913 20.3704 5.36048 20.1395C5.12967 19.9087 5 19.5957 5 19.2693V5.7308C5 5.40438 5.12967 5.09133 5.36048 4.86051C5.5913 4.6297 5.90435 4.50003 6.23077 4.50003H18.5385C18.8649 4.50003 19.1779 4.6297 19.4087 4.86051C19.6396 5.09133 19.7692 5.40438 19.7692 5.7308V19.2693C19.7692 19.5957 19.6396 19.9087 19.4087 20.1395C19.1779 20.3704 18.8649 20.5 18.5385 20.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69238 4.50003V20.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 8.80772H15.4618",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAddress;